import { render, staticRenderFns } from "./Pins.vue?vue&type=template&id=320d8dc2&scoped=true&"
import script from "./Pins.vue?vue&type=script&lang=js&"
export * from "./Pins.vue?vue&type=script&lang=js&"
import style0 from "./Pins.vue?vue&type=style&index=0&id=320d8dc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d8dc2",
  null
  
)

export default component.exports